"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: profile/profile-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fprofile%2Fprofile-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileUnauthenticatedServiceClient = exports.LookupProfileResponse = exports.LookupProfileRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const alias_1 = require("../common/alias");
const profile_profile_1 = require("./profile-profile");
const protobufPackage = 'com.step.profile.proto';
function createBaseLookupProfileRequest() {
    return { alias: alias_1.Alias.fromPartial({}) };
}
exports.LookupProfileRequest = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.LookupProfileRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupProfileRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        return message;
    },
};
function createBaseLookupProfileResponse() {
    return { profile: profile_profile_1.Profile.fromPartial({}) };
}
exports.LookupProfileResponse = {
    fromJSON(object) {
        const message = {
            profile: isSet(object.profile) ? profile_profile_1.Profile.fromJSON(object.profile) : profile_profile_1.Profile.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.profile !== undefined) {
            obj.profile = profile_profile_1.Profile.toJSON(message.profile);
        }
        return obj;
    },
    create(base) {
        return exports.LookupProfileResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupProfileResponse();
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? profile_profile_1.Profile.fromPartial(object.profile)
            : profile_profile_1.Profile.fromPartial({});
        return message;
    },
};
/**
 * Profile management API
 *
 * Manages profile (Pay Me Page)
 */
class ProfileUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.profile.proto.ProfileUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/profile';
    methods = [{
            name: 'LookupProfile',
            requestType: exports.LookupProfileRequest,
            responseType: exports.LookupProfileResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up profile. Used for unauthenticated people who entered through public web page.
     */
    lookupProfile(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ProfileUnauthenticatedServiceClient = ProfileUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=profile-unauthenticated-service.js.map